import React, { useState } from 'react';
import { Box, Container, useTheme, useMediaQuery, Typography } from '@mui/material';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import CheckerCancellationTable from '../components/CheckerCancellationTable';
import { Icon } from '@iconify/react';
interface CheckerInboxProps {
  onLogout: () => void;
}
export const CheckerInboxCancellation: React.FC<CheckerInboxProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-1381">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-1382" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="checker-cancellations" data-id="element-1383" />

      <Box component="main" sx={{
      flexGrow: 1,
      p: {
        xs: 2,
        md: 3
      },
      width: {
        sm: `calc(100% - 240px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-1384">
        <Container maxWidth="xl" disableGutters={isMobile} data-id="element-1385">
          <Box sx={{
          mb: 3
        }} data-id="element-1386">
            <Box sx={{
            width: 42,
            height: 42,
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#0052CC'
          }} data-id="element-1387">
              <Icon icon="lucide:clipboard-check" width={22} height={22} color="white" data-id="element-1388" />
            </Box>
            <Typography variant="h5" fontWeight={700} color="#1F2937" data-id="element-1389">
              Checker Inbox - Cancellations
            </Typography>
          </Box>

          <CheckerCancellationTable data-id="element-1390" />
        </Container>
      </Box>
    </Box>;
};
export default CheckerInboxCancellation;